import React from 'react';
import { Box, Typography } from '@mui/material';
import { StudioFlowColors } from '../studioFlowTheme';

interface BookOptionCardProps {
  label: string;
  imageSrc: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  wide?: boolean;
}

export const BookOptionCard: React.FC<BookOptionCardProps> = ({
  label,
  imageSrc,
  selected,
  onClick,
  disabled = false,
  wide = false,
}) => (
  <Box
    component="button"
    type="button"
    disabled={disabled}
    onClick={onClick}
    sx={{
      appearance: 'none',
      border: `1px solid ${selected ? StudioFlowColors.title : StudioFlowColors.selectionStroke}`,
      bgcolor: StudioFlowColors.background,
      borderRadius: '16px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      height: 112,
      pb: 1,
      p: 0,
      flex: wide ? '1 1 0' : '1 1 0',
      minWidth: 0,
      overflow: 'hidden',
      opacity: disabled ? 0.55 : 1,
    }}
  >
    <Box
      sx={{
        height: 80,
        overflow: 'hidden',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt=""
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center center',
          display: 'block',
        }}
      />
    </Box>
    <Typography
      sx={{
        fontFamily: StudioFlowColors.bodyFontFamily,
        fontWeight: 700,
        fontSize: 13,
        lineHeight: '16px',
        letterSpacing: '-0.13px',
        color: selected ? StudioFlowColors.title : StudioFlowColors.subtitle,
        textAlign: 'center',
        px: 0.5,
      }}
    >
      {label}
    </Typography>
  </Box>
);
